export const slideInContainer = (shown: boolean) =>
  `fixed h-screen bg-elr-purple-500 bg-opacity-50 transition-all ease-in-out duration-1000 ${
    !shown ? 'translate-x-full' : '-translate-x-0'
  } w-full md:w-screen top-0 left-0 z-100 md:overflow-hidden overflow-auto`;

export const slideInChildrenContainer = (overflow?: boolean) =>
  `${overflow ? 'overflow-y-auto md:overflow-y-auto relative md:pr-8 md:-mr-8' : ''} h-full pb-16`;
